<script setup lang="ts">
    defineOptions({ name: 'PageResolver' });

    const runtimeConfig = useRuntimeConfig();
    const route = useRoute();
    const isShopRoute = runtimeConfig.public.shopRoutes.some((routePath) => route.path.split('/').includes(routePath));
    const { lang } = useLanguage();

    if (!isShopRoute) {
        throw createError({
            statusCode: 404,
            statusMessage: 'Page not found'
        });
    }

    useHead({
        meta: [{ name: 'description', content: 'MEDICE Health Family' }],
        htmlAttrs: {
            lang: lang.value
        }
    });
</script>

<template>
    <FrontendDetailPage :key="route.fullPath" />
</template>
